import type { FilterItem, FilterItemPascal } from "./filterItem";
import type { KeyedArray } from "./keyedArray";

export interface SegmentFilter {
	brandId?: number | string;
	brandIds?: (number | string)[];

	channelId?: number | string;
	channelIds?: (number | string)[];

	marketerId?: number | string;
	marketerIds?: (number | string)[];

	stateId?: number | string;
	stateIds?: (number | string)[];

	branchId?: number | string;
	branchIds?: (number | string)[];

	repId?: number | string;
	repIds?: (number | string)[];
	allRepresentatives?: KeyedArray<RepFilterItem>;
	representatives?: KeyedArray<FilterItem>;

	/** (passed to api) If true, only load entities (channels, etc) with branches in them */
	onlyWithBranches?: boolean;
	/** (passed to api) If true, only load entities with active branches in them */
	onlyWithActiveBranches?: boolean;

	//Not passed to Api
	filterOutNoActiveBranches?: boolean;
}

export interface CurrentFilter extends SegmentFilter, IFilter {
	startDate?: Date;
	endDate?: Date;
}
export interface ActivableFilterItem extends FilterItem, FilterItem {
	Active: boolean;
	active?: boolean;
}
export interface BranchFilterItem extends ActivableFilterItem {
	marketerId: number;
	channelId: number;
	stateId: number;
	brandId: number;
	active: boolean;
}
export interface RepFilterItem extends FilterItemPascal, FilterItem {
	branchId: number;
	login: string;
}

export interface MarketFilterItem extends ActivableFilterItem {
	regionId: number;
	divisionId: number;
	companyId: number;
	active: boolean;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type changeHandler = (name: string, value: any) => void;

export interface IFilter {
	sortBy?: SortBy | null;
}

export interface SortBy {
	name: string;
	order: SortTypeEnum;
}

export enum SortTypeEnum {
	none = 0,
	ascending = 1,
	descending = -1,
}
